











 

























const node = {
  "kind": "InlineDataFragment",
  "name": "useUpdatedSafeRoute_meeting"
};

(node ).hash = "417166576cc730997426fdd9c3d33b99";

export default node;
